<style scoped lang="scss">
  @import "../user";
  @import "./ipone";
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">基因合成订单</h3>
      <div class="search-form">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="关联用户：" v-if="isHeadMan">
            <el-select v-model="searchForm.customerId" filterable clearable>
              <el-option
                      v-for="item in courseInfo.members"
                      :key="item.id"
                      :label="item.realName"
                      :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="时间：" class="date">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="bindSearch" class="search-button">搜索</el-button>
          </el-form-item>
        </el-form>
        订单状态：
        <el-radio-group v-model="status" @change="getOrders">
          <el-radio label="">全部</el-radio>
          <el-radio label="WAIT">待提交</el-radio>
          <el-radio label="NOT_STARTED">未开始</el-radio>
          <el-radio label="ING">进行中</el-radio>
          <el-radio label="OK">已完成</el-radio>
        </el-radio-group>
      </div>
      <el-table
        class="mt20"
        border
        :data="tableData">
        <el-table-column
          label="订单编号"
          width="200px">
          <template slot-scope="scope">
            <router-link :to="scope.row.userWebOrderStatus === 'WAIT' ?`/tec/gene_confirm?id=${scope.row.value.id}&fromPage=order` : `/user/gene_details?id=${scope.row.value.id}&fromPage=order`">{{scope.row.value.no}}</router-link>
          </template>
        </el-table-column>
        <el-table-column
          label="下单时间">
          <template slot-scope="scope">{{scope.row.value.createTime | rTime}}</template>
        </el-table-column>
        <el-table-column
          v-if="isHeadMan"
          prop="customerName"
          label="关联用户">
        </el-table-column>
        <el-table-column
          label="订单金额（元）">
          <template slot-scope="scope">
            <span v-if="scope.row.value.amount">{{scope.row.value.amount | amount}}</span>
            <span v-else>待询价</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="value.orderStatusName"
          label="订单状态">
        </el-table-column>
      </el-table>
      <div class="page tr">
        <el-pagination
          :page-size="10"
          :pager-count="10"
          layout="prev, pager, next"
          :total="total"
          @current-change="changePage">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { geneOrdersLists } from '@/services/api.index'
export default {
  data() {
    return {
      searchForm: {
        customerId: '',
        orderNo: '',
        date: null
      },
      status: this.$route.query.status || '',
      tableData: [],
      page: 0,
      pageSize: 10,
      total: 0,
      isHeadMan: this.baseMethods.isHeadMan(),
      courseInfo: this.baseMethods.getLocalObj('courseInfo'),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;  // 如果没有后面的-8.64e6就是不可以选择今天的
        }
      }
    }
  },
  created() {
    this.getOrders()
  },
  methods: {
    getOrders () {
      const { page, pageSize, status } = this
      let { orderNo, date, customerId } = this.searchForm
      date = date || ['', '']
      const searchIds = this.baseMethods.getSearchId(customerId)
      geneOrdersLists(page, pageSize, orderNo, ...date, status, ...searchIds).then(res => {
        res.data.list.map(item => {
          item.value.orderStatusName = this.baseMethods.orderStatus(item.userWebOrderStatus)
          if (item.userWebOrderStatus === 'WAIT') {
            item.value.orderStatusName = item.value.priceFlag ? '待提交待报价' : '待提交已报价'
          }
        })
        this.tableData = res.data.list
        this.total = res.data.totalCount
      })
    },
    bindSearch () {
      this.page = 0
      this.getOrders()
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getOrders()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/gene.vue